import { Card } from 'reactstrap';
import DynamicForm from '../../../../../../components/DynamicForm/DynamicForm';
import DymanicHealthCareCampus from '../../../../../../components/DynamicForm/parts/DymanicHealthCareCampus';
import DynamicContact from '../../../../../../components/DynamicForm/parts/DynamicContact';
import DynamicContactCampus from '../../../../../../components/DynamicForm/parts/DynamicContactCampus';
import DynamicContactPDI from '../../../../../../components/DynamicForm/parts/DynamicContactPDI';
import DynamicEducationalBackgroundCampus from '../../../../../../components/DynamicForm/parts/DynamicEducationalBackgroundCampus';
import DynamicEducationalBackgroundPDI from '../../../../../../components/DynamicForm/parts/DynamicEducationalBackgroundPDI';
import DynamicEmergencyContactPDI from '../../../../../../components/DynamicForm/parts/DynamicEmergencyContactPDI';
import DynamicFamilyContactCampus from '../../../../../../components/DynamicForm/parts/DynamicFamilyContactCampus';
import { STUDENT_INFO } from '../../../api/studentPersonalInfoRequests';
import StudentBackgroundNoSua from './StudentBackgroundNoSua';
import StudentBackgroundNoSuaCampus from './StudentBackgroundNoSuaCampus';
import StudentBackgroundNoSuaPDI from './StudentBackgroundNoSuaPDI';

const PostulantUpdateForm = ({
  defaultValues,
  photo,
}: {
  defaultValues: any;
  photo: string | null;
}) => {
  const sectionComponents = (photo: string | null) => {
    return {
      postulantInformation: (
        <StudentBackgroundNoSua
          prefix={'backgroundSection'}
          photo={photo}
          key={Math.floor(Math.random() * 100)}
        />
      ),
      postulantInformationCampus: (
        <StudentBackgroundNoSuaCampus
          prefix={'backgroundSection'}
          photo={photo}
          key={Math.floor(Math.random() * 100)}
        />
      ),
      academicContact: (
        <DynamicContact
          prefix={`academicContactSection`}
          key={Math.floor(Math.random() * 100)}
          disabled={true}
        />
      ),
      academicContactCampus: (
        <DynamicContactCampus
          prefix={'academicContactSection'}
          key={Math.floor(Math.random() * 100)}
          hasEmail={true}
          disabled={true}
        />
      ),
      highschoolInformationCampus: (
        <DynamicEducationalBackgroundCampus
          prefix={`highschoolInformationSection`}
          key={Math.floor(Math.random() * 100)}
          disabled={false}
        />
      ),
      healthCareCampus: (
        <DymanicHealthCareCampus
          prefix={'healtCareSection'}
          key={Math.floor(Math.random() * 100)}
          disabled={true}
        />
      ),
      familyContactCampus: (
        <DynamicFamilyContactCampus
          key={Math.floor(Math.random() * 100)}
          prefix={'familyGroupSection'}
          hasEmail
        />
      ),
      postulantInformationPDI: (
        <StudentBackgroundNoSuaPDI
          prefix={'backgroundSectionPDI'}
          photo={photo}
          key={Math.floor(Math.random() * 100)}
        />
      ),
      highschoolInformationPDI: (
        <DynamicEducationalBackgroundPDI
          prefix={'highschoolInformationSection'}
          key={Math.floor(Math.random() * 100)}
        />
      ),
      academicContactPDI: (
        <DynamicContactPDI
          prefix={`academicContactSection`}
          key={Math.floor(Math.random() * 100)}
          disabled={true}
        />
      ),
      emergencyContactPDI: (
        <DynamicEmergencyContactPDI
          prefix={`emergencyContactSection`}
          key={Math.floor(Math.random() * 100)}
        />
      ),
    };
  };

  return (
    <Card className="px-4 px-md-5 py-4">
      <DynamicForm
        source="teacher-student-file"
        key={1}
        formStructureUrl={STUDENT_INFO.FORM_STRUCTURE}
        defaultValues={defaultValues}
        sectionComponents={sectionComponents(photo)}
        onSubmit={async () => {}}
        formButtons={[]}
        readOnly={true}
      />
    </Card>
  );
};

export default PostulantUpdateForm;
